import { Button, Group, Modal, Select, Stack, Text } from "@mantine/core";
import { REJECT_REASONS } from "./constants";

export function PassConfirmModal({
  opened,
  candidateName,
  rejectReason,
  pending,
  onRejectReasonChange,
  onCancel,
  onConfirm,
}: {
  opened: boolean;
  candidateName: string | undefined;
  rejectReason: string | null;
  pending: boolean;
  onRejectReasonChange: (value: string | null) => void;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal opened={opened} onClose={onCancel} title="Pass this candidate?" centered>
      <Stack gap="md">
        <Text size="sm">
          {candidateName ?? "This candidate"} stays in the shared queue for other recruiters. You will not
          see them again for this job. Contact stays hidden.
        </Text>
        <Select
          label="Reason"
          data={REJECT_REASONS}
          value={rejectReason}
          onChange={onRejectReasonChange}
          placeholder="Why are they not a fit?"
        />
        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onCancel} disabled={pending}>
            Keep this person
          </Button>
          <Button color="gray" loading={pending} disabled={!rejectReason} onClick={onConfirm}>
            Pass
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
